<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-spacer></v-spacer>
      <v-btn icon @click="strichTabelleUpdate(-1)"><v-icon>keyboard_arrow_left</v-icon></v-btn>

      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-left="65"
        :nudge-bottom="10"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on"
            ><span class="title">{{ $filters.date(date) }}</span></v-btn
          >
        </template>
        <v-date-picker
          no-title
          scrollable
          prev-icon="keyboard_arrow_left"
          next-icon="keyboard_arrow_right"
          v-model="datepicker"
          @input="getDatepicker"
          locale="de-de"
        ></v-date-picker>
      </v-menu>

      <v-btn icon @click="strichTabelleUpdate(1)"><v-icon>keyboard_arrow_right</v-icon></v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>

    <v-row>
      <v-col cols="12">
        <v-card outlined class="mt-2">
          <v-row>
            <v-col cols="12" sm="8" md="4">
              <v-autocomplete label="Bundesbruder" :items="bundesbruderselect" v-model="bbrID"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="hidden-sm-and-up">
              <v-btn @click="stricheSet(-1)">-1</v-btn>
            </v-col>
            <v-col cols="3" class="hidden-sm-and-up">
              <v-btn @click="stricheSet(+1)">+1</v-btn>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-autocomplete label="EKP-Getränke" :items="getrankeselect" v-model="ekp"></v-autocomplete>
            </v-col>
            <v-col cols="4" sm="3" md="2">
              <v-text-field class="feld" name="" label="Anzahl Getränke" id="" v-model="ekp_anzahl"></v-text-field>
            </v-col>
            <v-col cols="4" sm="3" md="2">
              <v-text-field class="feld" name="" label="Pauschal" id="" v-model="pauschal"></v-text-field>
            </v-col>
            <v-col cols="8" sm="5" md="2">
              <v-text-field class="feld" name="" label="Grund" id="" v-model="grund"></v-text-field>
            </v-col>
            <v-btn absolute dark bottom right small fab class="mb-9 primary" @click="addItem"
              ><v-icon>add</v-icon></v-btn
            >
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" class="pt-2 pa-0">
        <v-simple-table fixed-header height="calc(100vh - 510px)">
          <thead>
            <tr>
              <th>Was</th>
              <th>Anzahl</th>
              <th>Preis</th>
              <th width="20px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td>{{ item.was }}</td>
              <td>{{ item.anzahl }}</td>
              <td>{{ item.preis | money }}</td>
              <td @click="deleteStrich(item)"><v-icon>delete</v-icon></td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" class="pt-4 text-right">
        Die Positionen werden nur gespeichert. <br />
        Die Rechnung kann unter Strichliste erstellt werden.
      </v-col>
      <v-col cols="2" class="text-center">
        <v-text-field outlined label="Summe" readonly :value="summe | money"></v-text-field>
      </v-col>
      <v-col cols="2" class="pt-4 text-right"> <v-btn large @click="saveItem">Speichern</v-btn> <br /> </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: ["props"],
    data() {
      return {
        date: new Date(),
        datepicker: new Date().toISOString().substr(0, 10),
        pauschal: "",
        getrankeselect: [],
        striche: "",
        items: [],
        grund: "",
        bbrID: "",
        ekp: "",
        ekp_anzahl: "",
        stricheheute: [],
        menu: false,
      };
    },
    computed: {
      summe() {
        let summe = 0;
        this.items.forEach((item) => {
          summe = parseFloat(summe) + parseFloat(item.preis);
        });
        return summe;
      },
      bundesbruderselect() {
        let items = this.$store.state.bbrbbr.bbrbbr;
        let bbrbbr = [];
        items.forEach((item) => {
          if (item.vulgo) {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname + " (" + item.vulgo + ")",
            });
          } else {
            bbrbbr.push({
              value: item.id,
              text: item.nachname + ", " + item.vorname,
            });
          }
        });
        return bbrbbr;
      },
    },
    methods: {
      addItem() {
        if (this.pauschal) {
          this.items.push({
            art: "pauschal",
            was: this.grund,
            anzahl: "pauschal",
            grund: this.grund,
            preis: this.pauschal,
            status: "",
          });
        }
        if (this.ekp) {
          this.items.push({
            art: "ekp",
            was: this.ekp[0].bezeichnung,
            ekp: this.ekp,
            anzahl: this.ekp_anzahl,
            preis: this.ekp[0].preis * this.ekp_anzahl,
            status: "",
          });
        }
        this.ekp = "";
        this.ekp_anzahl = "";
        this.pauschal = "";
        this.grund = "";
      },
      saveItem() {
        this.items.forEach((item) => {
          let eintrag;
          if (item.art === "ekp") {
            eintrag = {
              bbrID: this.bbrID,
              art: "ekp",
              ekp: item.ekp,
              date: this.date,
              preis: item.ekp[0].preis,
              anzahl: 1,
              status: "",
              grund: item.ekp[0].bezeichnung,
            };
            for (let i = 1; i <= item.anzahl; i++) {
              this.$store.dispatch("striche/createStrich", eintrag);
            }
          }
          if (item.art === "pauschal") {
            eintrag = {
              bbrID: this.bbrID,
              art: "pauschal",
              preis: item.preis,
              date: this.date,
              grund: item.grund,
              anzahl: 1,
              status: "",
            };
            this.$store.dispatch("striche/createStrich", eintrag);
          }
        });
        this.ekp = "";
        this.ekp_anzahl = "";
        this.pauschal = "";
        this.grund = "";
        this.items = [];
      },
      deleteStrich(value) {
        this.items.splice(this.items.indexOf(value), 1);
      },
      getDatepicker() {
        this.date = new Date(this.datepicker);
        this.datepicker = new Date(this.date).toISOString().substr(0, 10);
        this.menu = false;
      },
    },
    beforeMount() {
      this.$firebase
        .firestore()
        .collection("vereine")
        .doc(this.$vars.verbindung)
        .collection("getranke")
        .orderBy("bezeichnung")
        .onSnapshot(
          (querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.getrankeselect.push({
                value: [
                  {
                    id: doc.id,
                    preis: doc.data().verkauf1,
                    bezeichnung: doc.data().bezeichnung,
                  },
                ],
                text: doc.data().bezeichnung,
              });
            });
          },
          (err) => {
            console.log(`Encountered error: ${err}`);
          }
        );
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// bierwartVeranstaltung.vue?1f5d4ed5